import React from 'react';

function SpotifyEmbed({ spotifyId, active = true }) {
  if (!spotifyId || !active) return null;

  return (
    <div className="spotify-embed-slot">
      <iframe
        className="spotify-embed-frame"
        title="Spotify Player"
        src={`https://open.spotify.com/embed/artist/${spotifyId}?utm_source=generator&theme=0`}
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}

export default SpotifyEmbed;
